import { render, staticRenderFns } from "./COATypesImport.vue?vue&type=template&id=3a583609"
import script from "./COATypesImport.vue?vue&type=script&lang=js"
export * from "./COATypesImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports